import { ConfigurationModuleState } from "../configuration.state";

export const selectConfigurationState = (state: ConfigurationModuleState) => state.config;
